//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('travelBillMenu', {
//        templateUrl: 'views/components/views/travelBillMenu/travelBillMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'travelBillMenuService', 'logisticService', function ($stateParams, stateService, translateService, modalService, travelBillMenuService, logisticService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let travelBillNo = $stateParams.travelbill_no;
            
//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                bgTravelBillMenuMain: {
//                    selected: 'OVERVIEW',
//                    buttons: [
//                        { id: 'OVERVIEW', label: 'gb_travelbillmenu_main_overview', color: 'primary', onClick: () => vm.model.bgTravelBillMenuMain.selected = 'OVERVIEW' },
//                        { id: 'DETAILS', label: 'gb_travelbillmenu_main_details', color: 'primary', onClick: () => vm.model.bgTravelBillMenuMain.selected = 'DETAILS' },
//                        { id: 'PROCESSING', label: 'gb_travelbillmenu_main_processing', color: 'primary', onClick: () => vm.model.bgTravelBillMenuMain.selected = 'PROCESSING' }
//                    ]
//                },
//                customerNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('customersmenu', { cust_no: vm.model.menu.cust_no }) }
//                ],
//                projectNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('projectmenu', { project_keyno: vm.model.menu.project_keyno }) }
//                ],
//                specialHrsNoButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('sroperation', { custact_no: vm.model.menu.custact_no }) }
//                ],
//                customerActivityNoteButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('workdetails', { custact_no: vm.model.menu.custact_no }) }
//                ],
//                menu: {},
//                itemsListTravelBills: [],
//                lockedSendIn: false,
//                lockedApprove: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALLS

//            async function loadMenu() {
//                vm.model.menu = (await travelBillMenuService.getMenu({ travelbill_no: travelBillNo }))[0];
//            }

//            async function loadTravelBills() {
//                vm.model.itemsListTravelBills = await travelBillMenuService.listTravelBills({ travelbill_no: travelBillNo });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region BUTTON RADIO FUNCTIONS

//            vm.selectBgTravelBillMenuMain = function (value) {
//                vm.model.bgTravelBillMenuMain.selected = value;
//            }

//            // #endregion BUTTON RADIO FUNCTIONS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'travelwagedata':
//                        go({
//                            travelbill_no: vm.model.menu.travelbill_no,
//                            travelwagedata_keyno: '0'
//                        });
//                        break;
//                    case 'travelexpence':
//                        logisticService.getNextCounterNumber({ counter_id: 'travelexpence_keyno' }).then((response) => {
//                            state = 'travelexpence';

//                            go({
//                                travelbill_no: vm.model.menu.travelbill_no,
//                                travelexpence_keyno: response[0].nextnumber
//                            });
//                        });
//                        break;
//                    case 'travelbillreject':
//                        go({ travelbill_no: vm.model.menu.travelbill_no });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region SEND BUTTON FUNCTION

//            vm.send = function () {
//                vm.model.lockedSendIn = true;
                
//                travelBillMenuService.sendIn({ travelbill_no: vm.model.menu.travelbill_no }).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSendIn = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSendIn = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion SEND BUTTON FUNCTION

//            // #region APPROVE BUTTON FUNCTION
            
//            vm.approveExpenses = function () {
//                vm.model.lockedApprove = true;
                
//                travelBillMenuService.approve({ travelbill_no: vm.model.menu.travelbill_no }).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedApprove = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedApprove = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion APPROVE BUTTON FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadMenu();
//                loadTravelBills();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
